export const BRAND_NAME = 'Coretas';

// Product's handoff raster until the vector mark lands; a new file, never an overwrite of logo.svg.
export const BRAND_LOGO_ON_DARK = '/images/logo-white.png';
